<template>
    <div
      class="info-card-container"
      :style="{
        'background-color': backgroundColor
      }"
    >
      <div class="info-card-container__data">
        <p class="info-card-container__number">{{number | formatMoneyNumber}}</p>
        <p class="info-card-container__title">{{title}}</p>
      </div>
      <div class="info-card-contaioner__image">
        <el-image
          :src="image"
          fit="scale-down"></el-image>
      </div>
    </div>
</template>

<script>
export default {
  name: 'InfoCard',

  props: {
    backgroundColor: {
      type: String,
      default: '#aaaaaa'
    },
    number: {
      type: Number,
      default: 15300
    },
    title: {
      type: String,
      default: 'Name'
    },
    image: {
      default: ''
    }
  },

  data() {
    return {
      dateExample: ''
    }
  },

  methods: {
    methodExample() {}
  },

  computed: {
    computedExample() {
      return true
    }
  },

  filters: {
    formatMoneyNumber(val) {
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },

  components: {
    // EyeOffIcon,
  },

  created() {}
}
</script>

<style lang="scss">
    @import '../../styles/variables.scss';

    .info-card-container {
        width: 100%;
        height: 100%;
        min-height: 156px;
        border-radius: 30px;
        position: relative;
        .info-card-container__data {
          padding: 23px 0 0 20px;
          color: $certInfoCardColor;
          .info-card-container__number {
            font-size: 32px;
            font-weight: bold;
            line-height: 1.35;
            color: inherit;
          }
          .info-card-container__title {
            font-size: 14px;
            line-height: 1.33;
            letter-spacing: 0.3px;
            color: inherit;
          }
        }
        .info-card-contaioner__image {
          position: absolute;
          bottom: 16px;
          right: 16px;
          .el-image {
            width: 88px;
            height: 88px;
          }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Certificates/InfoCard.vue